
import "./Card.scss";
import classNames from 'classnames';
import { Card as ICard } from "../../models/Card";
import Button from "../common/Button";
import useLongPress from "../../hooks/useLongPress";
import store, { RootState } from "../../store/store";
import { previewActions } from "./previewSlice";
import { gameActions } from "../Game/gameSlice";
import { useAppSelector } from "../../hooks/redux";
import React, { useCallback, useEffect } from "react";

export default function Card(props: {
  card: ICard,
  cards?: ICard[],
  isSelected?: boolean,
  onSelect?: Function,
  onConfirm?: Function,
  onComment?: Function,
  isConfirm?: boolean,
  isConfirmable?: boolean,
  isSelectable?: boolean,
  classes?: string,
  confirmText?: string,
  confirmPrompt?: string | null,
  isLongPressEnabled?: boolean,
}) {
  const {
    card,
    cards,
    isSelected,
    onSelect,
    onConfirm,
    onComment,
    isConfirm = false,
    isConfirmable = true,
    isSelectable = false,
    isLongPressEnabled = true,
    confirmPrompt = null,
    classes = '',
    confirmText = 'Select'
  } = props;

  const longPress = useLongPress();

  const cardClass = classNames({
    'game-card': true,
    'game-card_selected': isSelected,
    'game-card_selectable': isSelectable,
    'game-card_disabled': !isSelectable || !onSelect,
  }, classes);

  const gameState = useAppSelector((state: RootState) => state.game);

  function previewCard(card: ICard) {
    store.dispatch(gameActions.sendCardView({ gameId: gameState.gameId, playerId: gameState.player?.data.playerId || null }));
    store.dispatch(previewActions.showPreview({ card: card, cards: cards }));
  }

  const longPressParams = isLongPressEnabled
    ? longPress(() => previewCard(card))
    : null;

  function onConfirmClick(e: any, card: ICard)  {
    if (e?.detail === 1) {
      if (onConfirm) {
        onConfirm(card.cardId);
      }
    }
  }

  function onCommentClick(e: any, card: ICard)  {
    if (e?.detail === 1) {
      if (onComment) {
        onComment(card.cardId);
      }
    }
  }

  function onClick(e: any, card: ICard)  {
    if (e) {
      e.preventDefault();
    }

    switch (e.detail) {
      case 1:
        if (onSelect) {
          onSelect();
        }
        break;
      case 2:
        previewCard(card);
        break;
      default:
        return;
    }
  }

  return (
    <>
      <div
        {...longPressParams}
        onClick={(e) => onClick(e, card)}
        className={cardClass}>
        <img src={card.src} alt="card" />
        {!!onConfirm && isConfirm &&
          <div className="game-card_button">
            <Button
              confirmPrompt={confirmPrompt}
              disabled={!isConfirmable}
              onClick={(e: any) => onConfirmClick(e, card)}
              text={confirmText}
            />
          </div>
        }
        {!!onComment &&
          <div className="game-card_comment">
            <div className="comment-icon" onClick={(e: any) => onCommentClick(e, card)}>&#x270E;</div>
          </div>
        }
      </div>
    </>
  )
}
